import ProfessionalHeadshots from './ProfessionalHeadshots'
export default ProfessionalHeadshots
